import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { toast } from "react-toastify";
import { selectActiveLocation } from "../common/slices/location";
import { sendHeadsUpMessage } from "../common/slices/user";
import { BlackButton, ButtonBase, LightButton } from "./Buttons";
import Divider from "./Divider";
import FormSelectCrewMember from "./FormSelectCrewMember";
import FormSelectLocation from "./FormSelectLocation";
import FormSelectRecipientType from "./FormSelectRecipientType";
import FormTextArea from "./FormTextArea";
import FormTextInput from "./FormTextInput";
import Modal from "./Modal";
import ModalSetPassword from "./ModalSetPassword";
import Row from "./Row";
import { H1, P } from "./Typography";
import FormSelectRole from "./FormSelectRole";
import { ErrorContext } from "../ErrorContext";

const MAX_MESSAGE_LENGTH = 1500;

const unmarshall = (input) => {
    return {
        type: input.type.value,
        locationId: input.locationId?.value,
        recipients: input.recipients?.map(r => r.value),
        subject: input.subject,
        roles: input.role?.map(r => r.value),
        body: input.body,
    }
}

const ModalSendMessage = ({ user, onClose }) => {
    const dispatch = useDispatch();
    const errorContext = useContext(ErrorContext);
    const [showPasswordModal, setShowPasswordModal] = useState(false);

    const {
        control,
        formState: { errors, isSubmitting, isValid },
        watch,
        handleSubmit
    } = useForm({
        values: {
            subject: "",
            body: ""
        },
    })

    const body = watch("body")
    const type = watch("type")
    const locationId = watch("locationId")
    const formProps = { control, errors, rules: { required: true } }

    const onSave = async (data) => {
        try {
            await dispatch(sendHeadsUpMessage(unmarshall(data)));
            toast.success("Message sent successfully");
            onClose();
        } catch (ex) {
            errorContext.setError({ errorMessage: "Failed to send heads up message", forSupport: ex.message })
        }
    }

    return (
        <Modal show size="60%" zindex='1200'>
            <Row>
                <H1>Create Message</H1>
                <ButtonBase onClick={onClose} style={{ marginLeft: 'auto' }}><FaTimes size='16px' color="#000" /></ButtonBase>
            </Row>

            <P>Select users to send a message to. This will be delivered in the form of a notification and pop up on the selected users app.</P>

            <Row>
                <FormSelectRecipientType name="type" label="Audience" {...formProps} />
                {(type?.value === "LOCATION" || type?.value === "INDIVIDUAL" || type?.value === "ROLE") && <FormSelectLocation name="locationId" label="Location" {...formProps} />}
                {type?.value === "ROLE" && <FormSelectRole name="role" label="Role" {...formProps} isMulti />}
            </Row>
            {type?.value === "INDIVIDUAL" && <FormSelectCrewMember showAll isMulti name="recipients" label="Crew Members" {...formProps} locationId={locationId?.value} />}

            <FormTextInput name="subject" label="Notification Title" placeholder="Enter a title for the notification" {...formProps} />
            <div>
                <FormTextArea name="body" label="Message" placeholder="Enter a message" rows={10} {...formProps} rules={{ required: true, maxLength: MAX_MESSAGE_LENGTH }} containerStyle={{ marginBottom: 0 }} />
                <P>{body?.length} / {MAX_MESSAGE_LENGTH}</P>
            </div>

            <Divider.Horizontal />
            <Row>
                <BlackButton onClick={handleSubmit(onSave)} disabled={isSubmitting || !isValid}>Send </BlackButton>
                <LightButton onClick={onClose} disabled={isSubmitting}>Cancel</LightButton>
            </Row>
            {showPasswordModal && <ModalSetPassword user={user} onClose={() => setShowPasswordModal(false)} zindex={9999} />}
        </Modal>
    );
};

export default ModalSendMessage;
